import { api } from './client'

export type MensagemDoConsole = {
  id: number
  origem: 'Cliente' | 'Assistente' | 'Atendente' | 'Sistema'
  texto: string
  em: string
  tipoDeEvento: string | null
}

export type EnvioDoConsole = {
  id: number
  tipo: 'Texto' | 'NotaPrivada' | 'Anexo' | 'AnexoPrivado' | 'QuadroDoOrcamento'
  situacao: 'Pendente' | 'Enviado' | 'Falhou' | 'Barrado'
  texto: string
  nomeDoAnexo: string | null

  /** No console isto é sempre verdadeiro — e é o desenho funcionando. */
  barrado: boolean
}

export type TransbordoDoConsole = {
  id: number
  motivo: string
  time: string | null
  causa: string | null
  em: string
}

export type DecisaoDoTurno = {
  id: number
  provedor: string
  modelo: string
  usouReserva: boolean
  tokensDeEntrada: number
  tokensDeSaida: number
  custo: number
  duracaoMs: number

  /** Só os NOMES. Os argumentos podem carregar dado de cliente e não são gravados. */
  ferramentas: string | null

  sucesso: boolean
  erro: string | null
  deTeste: boolean
}

/**
 * Um passo do traço: a ferramenta, o que o modelo mandou e o que voltou.
 *
 * 🔴 Vem do coletor em memória do servidor, nunca do banco — `RegistroDeDecisao`
 * continua guardando só os NOMES, porque em conversa real os argumentos podem
 * carregar dado de cliente.
 */
export type PassoDoTraco = {
  ferramenta: string
  argumentos: string
  retorno: string
  pediuTransbordo: boolean
}

export type SessaoDoConsole = {
  conversaId: number | null
  assistente: string
  deTeste?: boolean
  pausada?: boolean
  motivoDaPausa?: string | null
  mensagens: MensagemDoConsole[]
  envios?: EnvioDoConsole[]
  transbordos?: TransbordoDoConsole[]
  turno: {
    correlationId: string | null
    ferramentas: PassoDoTraco[]
    decisoes: DecisaoDoTurno[]
    tokensDeEntrada: number
    tokensDeSaida: number
    custo: number
  } | null
}

const raiz = (marca: string, assistenteId: number) =>
  `/marcas/${encodeURIComponent(marca)}/assistentes/${assistenteId}/console`

export const console_ = {
  ler: (marca: string, assistenteId: number) =>
    api.get<SessaoDoConsole>(raiz(marca, assistenteId)),

  responder: (marca: string, assistenteId: number, texto: string) =>
    api.post<SessaoDoConsole>(raiz(marca, assistenteId), { texto }),

  reiniciar: (marca: string, assistenteId: number) =>
    api.delete<void>(raiz(marca, assistenteId)),
}
